import { render } from "./RightOffersPanel.vue?vue&type=template&id=804687e0&scoped=true"
import script from "./RightOffersPanel.vue?vue&type=script&lang=js"
export * from "./RightOffersPanel.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-804687e0"

export default script